<template>
  <li class="oct-list-item">
    <component
      :is="$scopedSlots.meta ? 'label' : 'div'"
      class="oct-list-item__content"
    >
      <figure class="oct-list-item__graphic" v-if="media && media.image && media.image.lowResolution">
        <img :src="media && media.image && media.image.lowResolution" :alt="title" class="oct-list-item__image">
      </figure>

      <div class="oct-list-item__text">
        <span class="oct-list-item__primary-text">{{ title }}</span>
        <span class="oct-list-item__secondary-text">{{ text }}</span>
      </div>

      <div class="oct-list-item__meta">
        <slot name="meta" />
      </div>

      <div class="oct-list-item__meta oct-list-item__meta--handle">
        <oct-icon icon="drag-handle" />
      </div>

      <!-- @event 'remove' -->
      <div
        class="oct-list-item__action"
        @click="$emit('remove')"
        v-if="removable"
      >
        <oct-icon-button icon="close" size="small" />
      </div>
    </component>
  </li>
</template>

<script>
import OctIcon from '@/components/icon/OctIcon.vue';
import OctIconButton from '@/components/icon-button/OctIconButton.vue';

export default {
  name: 'OctListItem',
  components: { OctIcon, OctIconButton },
  props: {
    /** Graphic */
    media: {
      type: Object,
      default () {
        return {
          image: {
            standardResolution: '',
            lowResolution: '',
          }
        }
      }
    },
    /** Title text */
    title: {
      type: [String,Number],
      default: ''
    },
    /** Text under the title */
    text: {
      type: [String,Number],
      default: ''
    },
    /** Whether item can be removed */
    removable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-list-item {
  border-bottom: oct-rem(1.5) solid $oct-theme--primary;

  &:last-child {
    border-color: transparent;
  }

  .oct-list--bordered &,
  .oct-list--draggable & {
    margin: 0 0 oct-rem(8-1);
    padding: 0 0 oct-rem(8);
    border-color: transparent;
  }
}

.oct-list-item__content {
  position: relative;
  display: flex;
  align-items: center;
  padding: oct-rem(12) 0 oct-rem(12-1);

  .oct-list--bordered &,
  .oct-list--draggable & {
    min-height: oct-rem(72-2);
    padding: oct-rem(12-1) oct-rem(12-1);
    border: oct-rem(1) solid $oct-theme--primary;
    border-radius: oct-rem(8);
  }

  .oct-list--draggable & {
    cursor: pointer;
  }
}

.oct-list-item__graphic {
  margin: 0 oct-rem(12) 0 0;
  flex: 0 0 oct-rem(48);
  width: oct-rem(48);
  height: oct-rem(48);
  border-radius: 50%;
  overflow: hidden;
}

.oct-list-item__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.oct-list-item__text {
  flex: 1 1 auto;
  padding: oct-rem(5) 0; // avoid overflow cut over
  overflow: hidden;

  &:first-child {
    margin-left: oct-rem(8);
  }
}

.oct-list-item__primary-text {
  font-size: oct-rem(17);
  line-height: (24/17);
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: (-5em/17) 0 ((-5em+8)/17);
  display: block;
  overflow: hidden;
}

.oct-list-item__secondary-text {
  font-size: oct-rem(13);
  line-height: (18/13);
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: (-4em/13) 0;
  display: block;
  opacity: .55;
  overflow: hidden;
}

.oct-list-item__meta {
  flex: 0 0 auto;
  margin: 0 oct-rem(8) 0 oct-rem(12);

  .oct-list--draggable & {
    margin-right: 0;
  }
}

.oct-list-item__meta--handle {
  display: none;
  flex: 0 0 oct-rem(32);
  width: oct-rem(32);
  height: oct-rem(36);

  .oct-icon {
    width: 100%;
    height: 100%;
  }

  .oct-list--draggable & {
    display: block;
  }
}

.oct-select__dropdown-icon {
  position: absolute;
  top: 50%;
  right: oct-rem(17-4);
  width: oct-rem(20);
  height: oct-rem(20);
  transform: translateY(-50%);
  pointer-events: none;

  .oct-icon {
    width: 100%;
    height: 100%;
  }
}

.oct-list-item__action {
  position: absolute;
  top: 50%;
  left: 100%;
  margin-left: oct-rem(16);
  transform: translateY(-50%);
}
</style>
